import type { AxiosRequestConfig } from 'axios';
import type { MigratedCredentials } from '@entities/user';
import { RepositoryFactory } from '@main/factories/repository.factory';

export class HttpRequestInterceptors {
  static addBearerTokenInterceptor = (
    config: AxiosRequestConfig,
  ): AxiosRequestConfig => {
    const userRepository = RepositoryFactory.buildMemUserRepository();

    if (userRepository.user && config.headers) {
      const { idToken } = <MigratedCredentials>userRepository.user.credentials;

      config.headers['Authorization'] = `Bearer ${idToken}`;
    }

    return config;
  };
}
